export default __webpack_public_path__ + "static/media/17_calculator 2.fd54155b.gif";